import React, { useEffect, useState } from 'react'
import useStore from '../../../StorePeople/Store'
import stylesModal from '../styles.module.css'; // Assuming you have a CSS module with the required stylesModal
import JobLocation from './JobLocation/JobLocation'
import Location from './location/Location'
import Name from './name/Name'
import RecordRecency from './RecordRecency/RecordRecency'
import RequiredFields from './RequiredFields/RequiredFields'
// R33: New filter imports
import MostRecentPropertyPurchaseDate from './MostRecentPropertyPurchaseDate/MostRecentPropertyPurchaseDate'
import PropertiesOwnedDatePurchased from './PropertiesOwnedDatePurchased/PropertiesOwnedDatePurchased'
import PropertiesOwnedDateSold from './PropertiesOwnedDateSold/PropertiesOwnedDateSold'
import styles from './styles.module.css'; // Assuming you have a CSS module with the required stylesModal
import useEscapeKey from '../../../utils/useEscapeKey'

function ExpandedModal ({ onClose, isQueryLoading }) {
  const [isVisible, setIsVisible] = useState(false)

  // const { name, setName, lastName, setLastName } = useStore();
  const {
    fullName,
    setFullName,
    streetAddress,
    setStreetAddress,
    city,
    setCity,
    state,
    setState,
    postalCode,
    setPostalCode,
    country,
    setCountry,
    resetStore,
    recordRecency,
    setRecordRecency,
    // R33: New filter store values and setters
    mostRecentPropertyPurchaseDate,
    setMostRecentPropertyPurchaseDate,
    propertiesOwnedDatePurchased,
    setPropertiesOwnedDatePurchased,
    propertiesOwnedDateSold,
    setPropertiesOwnedDateSold
  } = useStore()

  const {
    title,
    setTitle,
    currentCompany,
    setCurrentCompany,
    requiredFields,
    setRequiredFields
  } = useStore()

  const [localFullName, setLocalFullName] = useState(fullName)
  const [localStreetAddress, setLocalStreetAddress] = useState(streetAddress)
  const [localCity, setLocalCity] = useState(city)
  const [localState, setLocalState] = useState(state)
  const [localPostalCode, setLocalPostalCode] = useState(postalCode)
  const [localCountry, setLocalCountry] = useState(country)

  const [localTitle, setLocalTitle] = useState(title)
  const [localCurrentCompany, setLocalCurrentCompany] = useState(currentCompany)
  const [localRequiredFields, setLocalRequiredFields] = useState(requiredFields)

  const [localRecordRecency, setLocalRecordRecency] = useState(
    recordRecency || { dateAdded: '', dateUpdated: '' }
  )

  // R33: New filter states - Initialize from store
  const [localMostRecentPropertyPurchaseDate, setLocalMostRecentPropertyPurchaseDate] = useState(
    mostRecentPropertyPurchaseDate || { startDate: '', endDate: '' }
  )
  const [localPropertiesOwnedDatePurchased, setLocalPropertiesOwnedDatePurchased] = useState(
    propertiesOwnedDatePurchased || { startDate: '', endDate: '' }
  )
  const [localPropertiesOwnedDateSold, setLocalPropertiesOwnedDateSold] = useState(
    propertiesOwnedDateSold || { startDate: '', endDate: '', includeNotSold: false }
  )

  // Function to handle backdrop click
  const handleBackdropClick = event => {
    // Check if the clicked element is the backdrop itself, not its children
    if (event.target === event.currentTarget) {
      setIsVisible(false)
      setTimeout(() => {
        onClose()
      }, 250)
    }
  }

  const handleClose = () => {
    // Start the slide-out effect
    setIsVisible(false)
    // Use a timeout to match the CSS transition duration
    setTimeout(() => {
      onClose()
    }, 250)
  }

  useEscapeKey(handleClose)

  useEffect(() => {
    // Trigger the slide-in effect when the component mounts
    const timeoutId = setTimeout(() => {
      setIsVisible(true)
    }, 1)

    return () => clearTimeout(timeoutId)
  }, [])

  useEffect(() => {
    if (isQueryLoading) {
      handleClose()
    }
  }, [isQueryLoading]) /* eslint-disable-line react-hooks/exhaustive-deps */

  const handleApplyFilters = () => {
    // Only proceed if not already loading
    if (!isQueryLoading) {
      // Update all filters, including price filter state
      setFullName(localFullName.name, localFullName.lastName)
      setStreetAddress(localStreetAddress)
      setCity(localCity)
      setState(localState)
      setPostalCode(localPostalCode)
      setCountry(localCountry)
      setTitle(localTitle)
      setCurrentCompany(localCurrentCompany)
      setRequiredFields(localRequiredFields)
      setRecordRecency(
        localRecordRecency.dateAdded,
        localRecordRecency.dateUpdated
      )
      // R33: Set new property ownership filters
      setMostRecentPropertyPurchaseDate(
        localMostRecentPropertyPurchaseDate.startDate,
        localMostRecentPropertyPurchaseDate.endDate
      )
      setPropertiesOwnedDatePurchased(
        localPropertiesOwnedDatePurchased.startDate,
        localPropertiesOwnedDatePurchased.endDate
      )
      setPropertiesOwnedDateSold(
        localPropertiesOwnedDateSold.startDate,
        localPropertiesOwnedDateSold.endDate,
        localPropertiesOwnedDateSold.includeNotSold
      )
      // close
      setIsVisible(false)
      setTimeout(() => {
        onClose()
      }, 250)
    }
  }

  const handleClearFilters = () => {
    // if (queryStore) {
    resetStore()
    // Reset the local states
    setLocalFullName({ name: '', lastName: '' })
    setLocalStreetAddress('')
    setLocalCity('')
    setLocalState('')
    setLocalPostalCode('')
    setLocalCountry('')
    setLocalTitle('')
    setLocalCurrentCompany('')
    setLocalRequiredFields([])
    setLocalRecordRecency({ dateAdded: '', dateUpdated: '' })
    // R33: Reset new property ownership filters
    setLocalMostRecentPropertyPurchaseDate({ startDate: '', endDate: '' })
    setLocalPropertiesOwnedDatePurchased({ startDate: '', endDate: '' })
    setLocalPropertiesOwnedDateSold({ startDate: '', endDate: '', includeNotSold: false })

    handleClose()
    // }
  }

  return (
    <div className={stylesModal.modalBackdrop} onClick={handleBackdropClick}>
      <div
        className={stylesModal.modalContent}
        style={{ transform: isVisible ? 'translateX(0)' : 'translateX(100%)' }}
        onClick={e => e.stopPropagation()}
      >
        <div className={stylesModal.modalHeader}>
          <h2 className={styles.ApiCallTitle}>Filters</h2>
          <div className={styles.containerButtonsFilters}>
            <span
              className={styles.buttonClearFilter}
              onClick={handleClearFilters}
            >
              Clear filters
            </span>
            <button
              className={styles.buttonApplyFilters}
              onClick={handleApplyFilters}
            >
              Apply filters
            </button>
          </div>
        </div>
        <hr className={styles.hrExpandedModal} />
        <section>
          <Name
            localFullName={localFullName}
            setLocalFullName={setLocalFullName}
          />
        </section>
        <hr className={styles.hrExpandedModal} />
        <section>
          <JobLocation
            localTitle={localTitle}
            setLocalTitle={setLocalTitle}
            localCurrentCompany={localCurrentCompany}
            setLocalCurrentCompany={setLocalCurrentCompany}
          />
        </section>
        <hr className={styles.hrExpandedModal} />
        <section>
          <Location
            localStreetAddress={localStreetAddress}
            setLocalStreetAddress={setLocalStreetAddress}
            localCity={localCity}
            setLocalCity={setLocalCity}
            localState={localState}
            setLocalState={setLocalState}
            localPostalCode={localPostalCode}
            setLocalPostalCode={setLocalPostalCode}
            localCountry={localCountry}
            setLocalCountry={setLocalCountry}
          />
        </section>

        <hr className={styles.hrExpandedModal} />

        <RecordRecency
          localRecordRecency={localRecordRecency}
          setLocalRecordRecency={setLocalRecordRecency}
        />

        <hr className={styles.hrExpandedModal} />

        {/* R33: New property ownership filters */}
        <MostRecentPropertyPurchaseDate
          mostRecentPropertyPurchaseDate={localMostRecentPropertyPurchaseDate}
          setMostRecentPropertyPurchaseDate={setLocalMostRecentPropertyPurchaseDate}
        />

        <hr className={styles.hrExpandedModal} />

        {/* R33: Properties owned group - side by side with checkbox as 3rd column */}
        <div className={styles.propertiesOwnedGroup}>
          <PropertiesOwnedDatePurchased
            propertiesOwnedDatePurchased={localPropertiesOwnedDatePurchased}
            setPropertiesOwnedDatePurchased={setLocalPropertiesOwnedDatePurchased}
          />

          <PropertiesOwnedDateSold
            propertiesOwnedDateSold={localPropertiesOwnedDateSold}
            setPropertiesOwnedDateSold={setLocalPropertiesOwnedDateSold}
          />

          <div className={styles.includeNotSoldColumn}>
            <div className={styles.includeNotSoldCheckboxWrapper}>
              <input
                type='checkbox'
                id='includeNotSold'
                className={styles.includeNotSoldCheckbox}
                checked={localPropertiesOwnedDateSold.includeNotSold}
                onChange={(e) => setLocalPropertiesOwnedDateSold({
                  ...localPropertiesOwnedDateSold,
                  includeNotSold: e.target.checked
                })}
              />
              <label htmlFor='includeNotSold' className={styles.includeNotSoldLabel}>
                Include properties not sold
              </label>
            </div>
          </div>
        </div>

        <hr className={styles.hrExpandedModal} />

        <section>
          <RequiredFields
            localRequiredFields={localRequiredFields}
            setLocalRequiredFields={setLocalRequiredFields}
          />
        </section>
      </div>
    </div>
  )
}

export default ExpandedModal
